import React, { Fragment, useEffect, useState } from "react";
import { Button, Dropdown, Menu, Radio, Space, Tag, Row } from "antd";
import PrivateGigsTag from "./PrivateGigsTag";
import "./AllGigsFilter.css";
import downArrow from "../../../../assets/icons/downArrow.png";
import { useDispatch, useSelector } from "react-redux";
import SearchDropDown from "../LocationFilter/SearchDropDown";
import ExperienceFilter from "../LocationFilter/ExperienceFilter";
import PrivateTag from "../../../../assets/icons/PrivateTag.svg";
import SkillDropDown from "../LocationFilter/SkillDropDown";
import {
  fetchMyGigsKeySearchSkills,
  GetFilters,
  getJobCounts,
  GetMyGigFilters,
  fetchFacilityRequest,
  keySearchMyGigsLocation,
} from "../../../../redux/actions";
import MobileViewFilter, {
  SORT_OPTIONS,
} from "../../../../components/PlaceBidModal/MobileViewFilter";
import debounce from "lodash/debounce";
import DEFAULT_FILTER_VALUES from "../../../../components/PlaceBidModal/PlaceBidModal";
import { EXPERIENCE_LEVELS } from "../../../../shared/helpers";
import { BILLING_ELIGIBLE_SOURCE } from "../../../../shared/billing";
const AllGigsFilter = ({
  handleApplyFilter,
  searchText,
  windowDimensions,
  searchFilters,
  setSearchFilters,
  webPadding = "0px 0px 0px 15px",
  tagPadding = "0px 10px 0px 15px",
  mobileButtonsPadding = undefined,
  showGigStatus = false,
  defaultParams = {},
}) => {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const userSource = String(
    userProfile?.Source || localStorage.getItem("cognitoSource") || ""
  )
    .trim()
    .toLowerCase();
  const isPtmEmployer =
    String(userProfile?.PvtEmpName || "").trim().toLowerCase() === "sg-ptm";
  const canShowPtmFilters =true
    // isPtmEmployer && userSource !== BILLING_ELIGIBLE_SOURCE;

  const [GigType, setGigType] = useState(false);
  const [gigStatus, setGigStatus] = useState(false);
  const [sortType, setSortType] = useState("MOST_RECENT");
  const dispatch = useDispatch();
  const filters = useSelector(
    (state) => state.searchSkillListingReducer.filters
  );
  const [CloseGigTypeModal, setCloseGigTypeModal] = useState(false);
  const [closeGigStatusModal, setCloseGigStatusModal] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [selectedGigType, setSelectedGigType] = useState(null);
  const [selectedVMS, setSelectedVMS] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [filterTags, setFilterTags] = useState([]);

  const AllGigMenu = (
    <Menu className={`skill-type-menu skill-type-menu2`}>
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <Radio.Group
          value={GigType}
          onChange={(e) => {
            handleGigType(e.target.value);
          }}
          style={{ width: "inherit" }}
          className="space radio-color "
        >
          <Space
            style={{ width: "inherit", rowGap: "16px" }}
            direction="vertical"
          >
            <Radio style={{ width: "inherit" }} value={false}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
              >
                <div>
                  All Jobs{" "}
                  <span style={{ marginLeft: "7.375rem" }}>
                    {/* (
                    {Count?.totalCount
                      ? Count?.totalCount?.[0]?.allGigs
                        ? Count?.totalCount?.[0]?.allGigs
                        : 0
                      : 0}
                    ) */}
                  </span>
                </div>
              </div>
            </Radio>
            <Radio style={{ width: "inherit" }} value={true}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "95%",
                  }}
                >
                  <span>
                    Private Jobs <img src={PrivateTag} alt="private" />
                  </span>
                  <span>
                    {/* (
                    {Count?.totalCount
                      ? Count?.totalCount[0]?.isPrivate
                        ? Count?.totalCount[0]?.isPrivate
                        : 0
                      : 0}
                    ) */}
                  </span>
                </div>{" "}
              </div>
            </Radio>
          </Space>
        </Radio.Group>
      </div>
    </Menu>
  );

  const GigStatusMenu = (
    <Menu className={`skill-type-menu skill-type-menu2`}>
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <Radio.Group
          value={gigStatus || "All"}
          onChange={(e) => {
            handleGigStatus(e.target.value);
          }}
          style={{ width: "inherit" }}
          className="space radio-color "
        >
          <Space
            style={{ width: "inherit", rowGap: "16px" }}
            direction="vertical"
          >
            <Radio style={{ width: "inherit" }} value={"All"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
              >
                <span>All </span>
                <span>
                  {/* (
                  {Count?.totalCount
                    ? Count?.totalCount?.[0]?.all
                      ? Count?.totalCount?.[0]?.all
                      : 0
                    : 0}
                  ) */}
                </span>
              </div>
            </Radio>
            <Radio style={{ width: "inherit" }} value={"Published"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
              >
                <span>Published</span>
                <span>
                  {/* (
                  {Count?.totalCount
                    ? Count?.totalCount[0]?.published
                      ? Count?.totalCount[0]?.published
                      : 0
                    : 0}
                  ) */}
                </span>
              </div>
            </Radio>
            <Radio style={{ width: "inherit" }} value={"Expired"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
              >
                <span>Expired</span>
                <span>
                  {/* (
                  {Count?.totalCount
                    ? Count?.totalCount[0]?.expired
                      ? Count?.totalCount[0]?.expired
                      : 0
                    : 0}
                  ) */}
                </span>
              </div>
            </Radio>
            <Radio style={{ width: "inherit" }} value={"Deleted"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
              >
                <span>Deleted</span>
                <span>
                  {/* (
                  {Count?.totalCount
                    ? Count?.totalCount[0]?.deleted
                      ? Count?.totalCount[0]?.deleted
                      : 0
                    : 0}
                  ) */}
                </span>
              </div>
            </Radio>
          </Space>
        </Radio.Group>
      </div>
    </Menu>
  );

  const clearFilter = () => {
    applyFilters({});
    updateFilters({});
    setGigType(false);
    setSelectedGigType(null);
    setSelectedCities([]);
    setSelectedCountries([]);
    setSelectedStates([]);
    setSelectedExperience(null);
    setSelectedSkill(null);
    setSelectedVMS([]);
    setSelectedFacility([]);
    setFilterTags([]);
    if(showGigStatus)setGigStatus(false)
    setSearchFilters({
      ...DEFAULT_FILTER_VALUES,
      MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
    });
  };

  const handleApplyDropDown = (value, key, tags = []) => {
  const _searchFilters = { ...searchFilters };
  _searchFilters[key] = value;
  if ([FILTER_KEYS.ExperienceLevel, FILTER_KEYS.JobOrderTypeName].includes(key)) {
    _searchFilters[getParamKeyforGqlApi(key)] = tags?.[0]?.title;
  } else {
    if (key === FILTER_KEYS.FacilityId) {
      _searchFilters[getParamKeyforGqlApi(key)] = value;
    } else {
      _searchFilters[getParamKeyforGqlApi(key)] = tags.map((el) => el.title);
    }
  }
  if (key === FILTER_KEYS.vms) {
    _searchFilters[FILTER_KEYS.FacilityId] = [];
    _searchFilters.facility = [];
    setSelectedFacility([]);
  }
  setSearchFilters({
    ..._searchFilters,
    MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
  });
  setFilterTags([
    ...filterTags.filter((el) =>
      key === FILTER_KEYS.vms
        ? ![FILTER_KEYS.vms, FILTER_KEYS.FacilityId].includes(el.filterKey)
        : el.filterKey !== key
    ),
    ...tags,
  ]);
  if (key === FILTER_KEYS.vms) {
    const payload = {
      vms: tags.map((el) => el.title), 
    };
    dispatch(fetchFacilityRequest(payload));
  }
  if (!isMobileView) applyFilters(_searchFilters);
  updateFilters(_searchFilters);
};

  const handleGigType = (value) => {
    setGigType(value);
    setSearchFilters({ ...searchFilters, isPrivateGig: value });
    applyFilters({ ...searchFilters, isPrivateGig: value });
    updateFilters({ ...searchFilters, isPrivateGig: value });
  };

  const handleGigStatus = (value) => {
    setGigStatus(value);
    setSearchFilters({ ...searchFilters, JobOrderStatusName: value });
    applyFilters({ ...searchFilters, JobOrderStatusName: value });
    updateFilters({ ...searchFilters, JobOrderStatusName: value });
  };

  const getParamKeyforGqlApi = (key) => {
    switch (key) {
      case FILTER_KEYS.JobOrderTypeName:
        return FILTER_KEYS.JobOrderTypeName;
      case FILTER_KEYS.SkillsId:
        return "Skills";
      case FILTER_KEYS.CityId:
        return "cities";
      case FILTER_KEYS.CountryId:
        return "countries";
      case FILTER_KEYS.RegionId:
        return "regions";
      case FILTER_KEYS.ExperienceLevel:
        return "explevel";
      case FILTER_KEYS.vms:
        return "vms";
      case FILTER_KEYS.FacilityId:
        return "facility";
      default:
        return key;
    }
  };

  const updateFilters = (data) => {
    const params = {
      value: "",
      body: {
        isPrivateGig: GigType,
        ...data,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        all: searchText || "",
        ...defaultParams,
      },
    };
    dispatch(keySearchMyGigsLocation(params));
    dispatch(fetchMyGigsKeySearchSkills(params));
  };

  const applyFilters = (filters = {}) => {
    const { JobOrderStatusName, ..._filters } = filters;
    handleApplyFilter({
      MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
      all: searchText || "",
      JobOrderStatusName: showGigStatus ? JobOrderStatusName : "All",
      ..._filters,
      ...defaultParams,
    });
  };

  const handleRemoveTag = ({ id, title, filterKey }) => {
    setFilterTags((prev) => [
      ...prev.filter((el) => !(el.id === id && el.filterKey === filterKey)),
    ]);
    const _searchFiltersCopy = {
      ...searchFilters,
      [filterKey]: [
        FILTER_KEYS.ExperienceLevel,
        FILTER_KEYS.JobOrderTypeName,
      ].includes(filterKey)
        ? null
        : searchFilters?.[filterKey]?.filter((el) => el !== id),
      [getParamKeyforGqlApi(filterKey)]: [
        FILTER_KEYS.ExperienceLevel,
        FILTER_KEYS.JobOrderTypeName,
      ].includes(filterKey)
        ? null
        : (() => {
          if (filterKey === FILTER_KEYS.FacilityId) {
            return searchFilters?.[getParamKeyforGqlApi(filterKey)]?.filter((el) => el !== id);  // IDs filter
          } else {
            return searchFilters?.[getParamKeyforGqlApi(filterKey)]?.filter((el) => el !== title);  // Baaki: titles filter
          }
        })(),
    };

    setSearchFilters(() => ({ ..._searchFiltersCopy }));
    applyFilters({
      isPrivateGig: GigType,
      ..._searchFiltersCopy,
      search: searchText || "",
      all: searchText || "",
    });
    updateFilters({
      isPrivateGig: GigType,
      ..._searchFiltersCopy,
      search: searchText || "",
      all: searchText || "",
    });

    removeSelectedValues(filterKey, title);
  };

  const removeSelectedValues = (filterKey, title) => {
    switch (filterKey) {
      case FILTER_KEYS.CityId:
        removeSelectedOption(title, selectedCities, setSelectedCities);
        return;
      case FILTER_KEYS.CountryId:
        removeSelectedOption(title, selectedCountries, setSelectedCountries);
        return;
      case FILTER_KEYS.RegionId:
        removeSelectedOption(title, selectedStates, setSelectedStates);
        return;
      case FILTER_KEYS.ExperienceLevel:
        setSelectedExperience(null);
        return;
      case FILTER_KEYS.JobOrderTypeName:
        setSelectedGigType(null);
        return;
      case FILTER_KEYS.SkillsId:
        setSelectedSkill(null);
        return;
      case FILTER_KEYS.vms:
        removeSelectedOption(title, selectedVMS, setSelectedVMS, filterKey);
        return;
      case FILTER_KEYS.FacilityId:
        removeSelectedOption(title, selectedFacility, setSelectedFacility, filterKey);
        return;
      default:
        return;
    }
  };

  const removeSelectedOption = (title, items, setItems, filterKey) => {
    setItems(items.filter((el) => getTitle(el, filterKey) !== title));
  };

  const isMobileView = windowDimensions.width < 768;

  const handleSort = (e) => {
    setSortType(e?.key);

    // Setting only publised gigs for upcoming expiry
    if (e?.key == "ENDING") handleGigStatus("Published");
    applyFilters({
      ...getGigStatusForSort(e?.key, searchFilters),
      _sort: e?.key,
    });
  };

  const getGigStatusForSort = (value, filters = {}) => {
    if (value == "ENDING") {
      return { ...filters, JobOrderStatusName: "Published" };
    } else return { ...filters, JobOrderStatusName: "All" };
  };

  const isShowClearAllButton = () => {
    return (showGigStatus && gigStatus) || GigType || filterTags.length > 0;
  };

  useEffect(() => {
    const params = {
      value: "",
      body: {
        ...searchFilters,
        all: searchText || "",
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        isPrivateGig: false,
        ...defaultParams,
      },
    };
    dispatch(keySearchMyGigsLocation(params));
    dispatch(fetchMyGigsKeySearchSkills(params));
  }, []);

  const sortMenu = (
    <Menu onClick={handleSort}>
      {SORT_OPTIONS.map((el) => (
        <Menu.Item
          key={el.value}
          className={
            sortType == el?.value ? "sort-values-style-select" : "Most Relevant"
          }
        >
          {el.title}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Fragment>
      <MobileViewFilter
        setGigStatus={handleGigStatus}
        gigStatus={gigStatus}
        setGigType={handleGigType}
        GigType={GigType}
        isMobileView={isMobileView}
        handleApplyDropDown={handleApplyDropDown}
        searchFilters={{ ...(searchFilters || {}) }}
        experienceOptions={EXPERIENCE_LEVELS}
        applyMobileFilters={applyFilters}
        clearAll={clearFilter}
        searchText={searchText}
        showGigStatus={showGigStatus}
        defaultParams={defaultParams}
        {...{
          selectedCities,
          setSelectedCities,
          selectedStates,
          setSelectedStates,
          selectedSkill,
          setSelectedSkill,
          selectedExperience,
          setSelectedExperience,
          selectedCountries,
          setSelectedCountries,
          selectedGigType,
          setSelectedGigType,
          selectedVMS,
          setSelectedVMS,
          sortType,
          setSortType,
          mobileButtonsPadding,
          selectedFacility,
          setSelectedFacility
        }}
      />

      {!isMobileView && (
        <Fragment>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "no-wrap",
              rowGap: "15px",
              padding: webPadding,
            }}
          >
            <Space wrap className="space" sx={{ paddingBottom: 4 }}>
              {userProfile?.IsPrivateEmployer ? (
                <Dropdown
                  destroyPopupOnHide={true}
                  overlay={AllGigMenu}
                  trigger="click"
                  className={"dropdown-job"}
                  visible={CloseGigTypeModal}
                  onOpenChange={(e) => {
                    setCloseGigTypeModal(!CloseGigTypeModal);
                  }}
                >
                  <Button className="skill-list-type-dropdown All_gigs_filter visaStatus-dropdown-select">
                    All jobs
                    <img
                      alt=""
                      src={downArrow}
                      style={{
                        width: "8px",
                      }}
                    />
                  </Button>
                </Dropdown>
              ) : null}

              {/* Gig Status */}
              {showGigStatus && (
                <Dropdown
                  destroyPopupOnHide={true}
                  // overlayClassName="searchResultsFilterDropdown"
                  overlay={GigStatusMenu}
                  trigger="click"
                  className={"dropdown-job"}
                  visible={closeGigStatusModal}
                  onOpenChange={(e) => {
                    setCloseGigStatusModal(!closeGigStatusModal);
                  }}
                >
                  <Button className="skill-list-type-dropdown All_gigs_filter visaStatus-dropdown-select">
                    Job status
                    <img
                      alt=""
                      src={downArrow}
                      style={{
                        width: "8px",
                      }}
                    />
                  </Button>
                </Dropdown>
              )}

              <ExperienceFilter
                label="Job Type"
                isSelected={searchFilters?.JobOrderTypeName}
                filterKey={FILTER_KEYS.JobOrderTypeName}
                handleApply={handleApplyDropDown}
                value={searchFilters?.JobOrderTypeName}
                selectedOptions={selectedGigType}
                setSelectedOptions={setSelectedGigType}
                defaultParams={defaultParams}
              />

              <SkillDropDown
                filterKey={"SkillsId"}
                isSelected={searchFilters?.SkillsId}
                label={"Skill"}
                paramKey="skill"
                handleApply={handleApplyDropDown}
                searchFilters={searchFilters}
                selectedOptions={selectedSkill}
                setSelectedOptions={setSelectedSkill}
                searchText={searchText}
                defaultParams={defaultParams}
              />

              <SearchDropDown
                filterKey={"CountryId"}
                isSelected={searchFilters?.CountryId?.length}
                label={"Country"}
                paramKey="country"
                handleApply={handleApplyDropDown}
                searchFilters={searchFilters}
                selectedOptions={selectedCountries}
                searchText={searchText}
                setSelectedOptions={setSelectedCountries}
                defaultParams={defaultParams}
              />

              <SearchDropDown
                filterKey={"RegionId"}
                isSelected={searchFilters?.RegionId?.length}
                label={"State"}
                paramKey="region"
                handleApply={handleApplyDropDown}
                searchFilters={searchFilters}
                selectedOptions={selectedStates}
                searchText={searchText}
                setSelectedOptions={setSelectedStates}
                defaultParams={defaultParams}
              />

              <SearchDropDown
                filterKey={"CityId"}
                isSelected={searchFilters?.CityId?.length}
                label={"City"}
                handleApply={handleApplyDropDown}
                searchFilters={searchFilters}
                selectedOptions={selectedCities}
                searchText={searchText}
                setSelectedOptions={setSelectedCities}
                defaultParams={defaultParams}
              />

              <ExperienceFilter
                filterKey={FILTER_KEYS.ExperienceLevel}
                label="Experience Level"
                isSelected={searchFilters?.explevel}
                options={EXPERIENCE_LEVELS}
                handleApply={handleApplyDropDown}
                value={searchFilters?.explevel}
                selectedOptions={selectedExperience}
                setSelectedOptions={setSelectedExperience}
                defaultParams={defaultParams}
              />

              {canShowPtmFilters && (
  <>
    <SearchDropDown
      filterKey={FILTER_KEYS.vms}
      isSelected={searchFilters?.vms?.length}
      label="VMS"
      paramKey="vms"
      handleApply={handleApplyDropDown}
      searchFilters={searchFilters}
      selectedOptions={selectedVMS}
      setSelectedOptions={setSelectedVMS}
      searchText={searchText}
      defaultParams={defaultParams}
    />

    <SearchDropDown
      filterKey={FILTER_KEYS.FacilityId}
      isSelected={searchFilters?.FacilityId?.length}
      label="Facility"
      paramKey="facility"
      handleApply={handleApplyDropDown}
      searchFilters={searchFilters}
      selectedOptions={selectedFacility}
      setSelectedOptions={setSelectedFacility}
      searchText={searchText}
      defaultParams={defaultParams}
      vmsSelected={selectedVMS}
    />
  </>
)}

            </Space>
            <div className="applied-filter">
              <div className="div2-searchResults">
                <div className="sort-Text">Sort by</div>
                <Dropdown
                  // overlayClassName="sortByFilterDropdown"
                  overlay={sortMenu}
                  trigger={["click"]}
                  // className="dropdown1"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                  <Space style={{ border: "none" }}>
                    <div
                      className="location-lists-container"
                      style={{ maxHeight: "250px" }}
                    >
                      <a
                        style={{ border: "none" }}
                        onClick={(e) => e.preventDefault()}
                      >
                        <div className="filterDropDownText">
                          {SORT_OPTIONS.find((el) => el.value == sortType)
                            ?.title || "Most Recent"}
                        </div>
                      </a>
                    </div>
                    <img
                      src={downArrow}
                      style={{
                        width: "8px",
                        cursor: "pointer",
                        marginBottom: "2px",
                      }}
                    />
                  </Space>
                </Dropdown>
              </div>
            </div>
          </div>

          <Row
            style={{ marginTop: "20px", padding: tagPadding }}
            gutter={[4, 8]}
          >
            {GigType ? (
              <Tag
                closable={true}
                onClose={() => handleGigType(false)}
                className="filter-tag"
              >
                Private Jobs <img src={PrivateTag} alt="Private" />
              </Tag>
            ) : null}
            {showGigStatus && gigStatus ? (
              <Tag
                closable={true}
                onClose={() => handleGigStatus(false)}
                className="filter-tag"
              >
                {gigStatus}
              </Tag>
            ) : null}
            {filterTags.map((el) => (
              <Tag
                key={el.id + el.title}
                closable={true}
                onClose={() => handleRemoveTag(el)}
                className="filter-tag"
              >
                {el.title}
              </Tag>
            ))}
            {isShowClearAllButton() ? (
              <Tag
                style={{
                  marginLeft: "auto",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                closable={false}
                onClick={() => clearFilter()}
                className="filter-tag"
              >
                Clear All
              </Tag>
            ) : null}
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
};

export const FILTER_KEYS = {
  JobOrderTypeName: "JobOrderTypeName",
  SkillsId: "SkillsId",
  CountryId: "CountryId",
  RegionId: "RegionId",
  CityId: "CityId",
  ExperienceLevel: "ExperienceLevel",
  vms: "vms",
  FacilityId: "FacilityId"
};

const getTitle = (item, filterKey) => {
  switch (filterKey) {
    case FILTER_KEYS.CityId:
      return item?.LocationWithCountry;
    case FILTER_KEYS.CountryId:
      return item?.CountryName;
    case FILTER_KEYS.RegionId:
      return item?.RegionName;
    case FILTER_KEYS.vms:
      return item?.VMSName;
    case FILTER_KEYS.FacilityId:
      return item?.FacilityName;
    default:
      return "";
  }
};

export default AllGigsFilter;
